export default "__VITE_ASSET__GU26hWC8__"